import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../api";

export default function PromoterCommissions() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/me/commissions")
      .then((res) => setItems(res.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="promoter-commissions-page">
      <header className="page-head">
        <div>
          <Link to="/portal" className="back-link">← Dashboard</Link>
          <h1>My Commissions</h1>
        </div>
      </header>

      {loading ? (
        <div className="loading">Loading…</div>
      ) : items.length === 0 ? (
        <div className="empty" data-testid="commissions-empty">
          No commissions yet. They appear here once your referrals convert.
        </div>
      ) : (
        <div className="table-wrap">
          <table data-testid="commissions-table">
            <thead>
              <tr>
                <th>Order</th><th>Date</th><th>Product</th><th>Commissionable</th>
                <th>%</th><th>Commission</th><th>Currency</th>
                <th>Maturity</th><th>Payment</th><th>Payable</th><th>Paid</th>
              </tr>
            </thead>
            <tbody>
              {items.map((c) => (
                <tr key={c.id} data-testid={`commission-row-${c.id}`}>
                  <td>{c.orderNumber}</td>
                  <td>{c.orderDate ? new Date(c.orderDate).toLocaleDateString() : "—"}</td>
                  <td>{c.productTitle}</td>
                  <td>{c.commissionableAmount}</td>
                  <td>{c.appliedRate ?? "—"}</td>
                  <td>{c.commissionAmount}</td>
                  <td>{c.currency}</td>
                  <td><span className="badge badge-yellow">{c.maturityStatus}</span></td>
                  <td><span className="badge badge-gray">{c.paymentStatus}</span></td>
                  <td>{c.payableAt ? new Date(c.payableAt).toLocaleDateString() : "—"}</td>
                  <td>{c.paidAt ? new Date(c.paidAt).toLocaleDateString() : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
